module.exports = __webpack_public_path__ + "img/46.a73c9dd8.jpg";